<script>
import { mapActions } from 'vuex';
import i18n from "@/plugins/i18n";

export default {
    props: {
        companyId: {
            required: true,
            type: Number
        },

        isTeam: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            loading: false,
            isLoadingMore: false,
            loadMore: false,
            users: [],
            keyword: null,
            sortBy: null,
            increasing: true,
            currentPage: 1,
            isDeleted: false,
            roles: [],
            departments: [],
            userToUpdate: null,
            userToUpdateCopy: null,
            userToCreate: {
                user_department_id: null,
                role_id: null,
                firstname: null,
                surname: null,
                email: null,
                user_language: null,
            },

            selectedBulkRegisterFile: null,

            missingInformation: [],
            existingStakeholders: [],
            selectedPostInfoTab: null,
        }
    },

    computed: {
        tableHeaders() {
            return [
                {text: "#", width: "4.5%", key: "row"},
                {text: i18n.t("userCompany.user.name"), width: "20%", key: "firstname"},
                {text: i18n.t("userCompany.user.surname"), width: "20%", key: "surname"},
                {text: i18n.t("userCompany.user.email"), width: "20%", key: "email"},
                {text: i18n.t("userCompany.user.department"), width: "20%", key: "user_department_name"},
                {text: i18n.t("userCompany.user.role"), width: "10%", key: "role_name"},
                {text: i18n.t("userCompany.user.edit"), no_click:true , width: "5%",   key: "edit"},
                {text: i18n.t("userCompany.user.delete"), no_click:true , width: "5%",  key: "delete"}
            ]
        },
        
        postInfoTableHeaders() {
            return [
                {text: "#", width: "4.5%", key: "row"},
                {text: i18n.t("userCompany.user.name"), width: "20%", key: "firstname"},
                {text: i18n.t("userCompany.user.surname"), width: "20%", key: "surname"},
                {text: i18n.t("userCompany.user.email"), width: "20%", key: "email"},
                {text: i18n.t("userCompany.user.role"), width: "10%", key: "stakeholder_role"},
                {text: i18n.t("userCompany.user.department"), width: "20%", key: "user_department"},
                {text: i18n.t("userCompany.user.language"), width: "10%", key: "user_language"},
            ]
        },

        filteredRoles() {
            if (this.roles.length === 0) return [];
            if (this.$user.role_id <= 3) return this.roles;
            return this.roles.filter(x => x.value === 6 || x.value === 7);
        },

        filteredDepartmentsUpdate() {
            if (!this.userToUpdate || !this.userToUpdate.role_id || this.userToUpdate.role_id === 1)
                return this.departments;

            const is_internal = this.userToUpdate.role_id <= 6;
            if (is_internal) {
                return this.departments.filter(x => x.role_id === 6);
            } else {
                return this.departments.filter(x => x.role_id === 7);
            }
        },

        filteredDepartmentsCreate() {
            if (!this.userToCreate || !this.userToCreate.role_id || this.userToCreate.role_id === 1)
                return this.departments;

            const is_internal = this.userToCreate.role_id <= 6;
            if (is_internal) {
                return this.departments.filter(x => x.role_id === 6);
            } else {
                return this.departments.filter(x => x.role_id === 7);
            }
        },

        filteredPostInfoTable() {
            if (this.selectedPostInfoTab === 'missing') {
                return this.missingInformation; 
            } else if (this.selectedPostInfoTab === 'existing') {
                return this.existingStakeholders; 
            } else {
                return [];
            }
        },
    },


    async mounted() {
        await this._getRoles();
        await this._getDepartments();
        await this._getUsersOfCompany();
    },

    methods: {
        ...mapActions("settings", [
            "getUsersOfCompany",
            "getRoles",
            "getDepartments",
            "updateUser",
            "deleteUser",
            "registerUser",
            "bulkRegisterUser",
            "getSampleExcel",
            "exportUsers"
        ]),

        async _getRoles() {
            const params = {
                role_id: this.$user.role_id
            }

            const lang = localStorage.getItem("lang");

            this.getRoles(params)
                .then(res => {
                    this.roles = res.data.filter(x => x.role_id != 8).map(item => {
                        return {
                            text: lang == 'tr' && item.role_name_tr ? item.role_name_tr : item.role_name,
                            value: item.role_id
                        }
                    })
                })
                .catch(({ response }) => {
                    console.error(response.message);
                })
        },

        async _getDepartments() {
            const params = {
                is_deleted: false
            }

            const lang = localStorage.getItem("lang");

            this.getDepartments(params)
                .then(res => {
                    this.departments = res.data.map(item => {
                        return {
                            text: lang == 'tr' && item.user_department_name_tr ? item.user_department_name_tr : item.user_department_name,
                            value: item.user_department_id,
                            role_id: item.role_id 
                        }
                    })
                })
                .catch(({ response }) => {
                    console.error(response.message);
                })
        },

        async _getUsersOfCompany() {
            const params = {
                /* is_deleted: this.isDeleted, */
                company_id: this.companyId,
                keyword: this.keyword,
                sort_by: this.sortBy == 'row' ? null : this.sortBy,
                increasing: this.increasing,
                page: this.currentPage,
                is_team: this.isTeam
            }

            await this.setLoading(true);

            await this.getUsersOfCompany(params)
                .then(async (res) => {
                    await this.setUsers(res.data.users);
                    await this.setLoadMore(res.data.load_more);
                })
                .catch(({ response }) => {
                    if (params.is_deleted == true) {
                        this.$notify('info' , response.data.messageName);
                    } else {
                        this.$notify("error", response.data.messageName);
                    }
                })
                .finally(async () => {
                    setTimeout(async () => {
                        await this.setLoading(false);
                    }, 200);
                })
        },

        async _updateUser() {
            let params = {
                user_id: this.userToUpdate.user_id,
                body: {}
            };

            for (let i = 0; i < Object.keys(this.userToUpdate).length; i++) {
                const key = Object.keys(this.userToUpdate)[i];
                
                if (Object.prototype.hasOwnProperty.call(this.userToUpdateCopy, key) && this.userToUpdateCopy[key] != this.userToUpdate[key] && key != 'user_id') {
                    Object.assign(params.body, { [key]: this.userToUpdate[key] });
                }
            }

            await this.updateUser(params)
                .then(res => {
                    this.$notify('success', res.data.messageName);
                })
                .catch(({ response }) => {
                    this.$notify('error', response.data.messageName);
                })
        },

        async _deleteUser() {
            const params = {
                user_id: this.userToUpdate.user_id
            }

            await this.deleteUser(params)
                .then(res => {
                    this.$notify('success', res.data.messageName);
                    this.users=this.users.filter(user => user.user_id !== this.userToUpdate.user_id);
                    this.resetUpdateUser();
                })
                .catch(({ response }) => {
                    this.$notify('error', response.data.messageName);
                })
        },

        async _registerUser() {
            const params = {
                created_by: this.$user.user_id,
                company_id: this.companyId,
                user_department_id: this.userToCreate.user_department_id,
                role_id: this.userToCreate.role_id,
                firstname: this.userToCreate.firstname,
                surname: this.userToCreate.surname,
                email: this.userToCreate.email,
                user_language: this.userToCreate.user_language,
                expert_firstname: this.userToCreate.firstname,
                expert_surname: this.userToCreate.surname
            };

            await this.registerUser(params)
                .then(res => {
                    const department = this.departments.find(dep => dep.value === this.userToCreate.user_department_id);
                    const role = this.roles.find(role => role.value === this.userToCreate.role_id);
                    this.users.push({
                        ...this.userToCreate,
                        user_department_name: department ? department.text : '',
                        role_name: role ? role.text : '',
                        user_id: res.data.user_id,
                    });
                    let stakeHolderType = "internal";
                    if(this.userToCreate.role_id == 7){
                        stakeHolderType = "external";
                    }
                    this.$emit('userRegister', stakeHolderType); 
                    this.$notify('success', res.data.messageName);
                    this.resetRegisterUser();

                    
                })
                .catch(({ response }) => {
                    this.$notify('error', response.data.messageName);
                })
            
        },

        async _bulkRegisterUser() {
            const createdUsername = localStorage.getItem("firstname") + localStorage.getItem("surname");
            let fd = new FormData();
            fd.append("files", this.selectedBulkRegisterFile);
            fd.append("company_id", this.companyId);
            fd.append("created_by", this.$user.user_id);
            fd.append("created_username", createdUsername);
            fd.append("role_id", this.$user.role_id);
            
            this.bulkRegisterUser(fd)
                .then(res => {
                    this.$notify('success', res.data.messageName);
                    
                    this.missingInformation = res.data.missing_information;
                    this.existingStakeholders = res.data.existed_users;

                    if (this.missingInformation.length > 0) {
                        this.selectedPostInfoTab = 'missing';
                        this.$refs.missingInfoPopup.openPopup();
                    } else if (this.existingStakeholders.length > 0) {
                        this.selectedPostInfoTab = 'existing';
                        this.$refs.missingInfoPopup.openPopup();
                    }
                })
                .catch(({ response }) => {
                    this.$notify('error', response.data.messageName);
                })
                .finally(async () => {
                    await this._getUsersOfCompany();
                    await this.handleBulkRegisterCancel();
                })
        },

        async _getSampleExcel() {
            this.getSampleExcel()
                .then((response) => {
                    const url = URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute(
                        'download',
                        i18n.t('userCompany.user.sample_excel_name')
                    );
                    document.body.appendChild(link);
                    link.click();
                })
        },

        async _exportUsers() {
            const params = {
                company_id: this.companyId,
                is_deleted: this.isDeleted
            }
            
            this.exportUsers(params)
                .then( response => {
                    const url = URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute(
                        'download',
                        i18n.t('userCompany.user.users_excel_name')
                    );
                    document.body.appendChild(link);
                    link.click();
                })
                .catch(({ response }) => {
                    this.$notify('error', response.data.messageName);
                })
        },

        async handleSortBy(header) {
            if(header.no_click) return;

            if (this.sortBy != header.key) {
                await this.setIncreasing(false);
                await this.setSortBy(header.key);
            } else {
                await this.setIncreasing(!this.increasing);
            }
            await this._getUsersOfCompany();
        },

        async handleLoadMore() {
            await this.setIsLoadingMore(true);
            await this.increaseCurrentPage();
            await this._getUsersOfCompany();
            setTimeout(async () => {
                await this.setIsLoadingMore(false);    
            }, 150);
        },

        handleClickEdit(user) {
            if (this.isDeleted || user.role_id <= this.$user.role_id) return;

            this.userToUpdate = user;
            this.userToUpdateCopy = structuredClone(user);
            this.$refs.editPopup.openPopup();
        },

        handleClickDelete(user) {
            if (this.isDeleted || user.role_id <= this.$user.role_id) return;

            this.userToUpdate = user;
            this.$refs.deletePopup.openPopup();
        },

        handleClickRegister() {
            this.$refs.createPopup.openPopup();
        },

        handleClickBulk() {
            this.$refs.bulkPopup.openPopup();
        },

        handleClickChooseFile() {
            this.$refs.fileInput.click();
        },

        handleChooseFile(e) {
            this.selectedBulkRegisterFile = e.target.files[0];
        },

        handleBulkRegisterCancel() {
          this.$refs.bulkPopup.startHideProcess();  
        },

        async handleBulkRegisterConfirm() {
            await this._bulkRegisterUser();
        },

        async handleShowDeletedUsers(state) {
            await this.setIsDeleted(state);
            setTimeout(async () => {
                try {
                    await this._getUsersOfCompany();
                } catch (error) {
                    await this.setIsDeleted(false);
                    this.$notify('info', i18n.t('userCompany.user.no_deleted_user'), true);
                }
            }, 125);
        },

        // setters //

        async setLoading(bool) {
            this.loading = bool;
        },

        async setIsLoadingMore(bool) {
            this.isLoadingMore = bool;
        },

        async setLoadMore(bool) {
            this.loadMore = bool
        },

        async setUsers(data) {
            this.users = data;
        },

        async handleReset() {
            await this.resetKeyword();
            await this.setSortBy(null);
            await this.setIncreasing(false);
            await this._getUsersOfCompany();
        },

        async resetKeyword() {
            this.keyword = null;
        },

        async setSortBy(key) {
            this.sortBy = key;
        },

        async setIncreasing(bool) {
            this.increasing = bool;
        },

        async increaseCurrentPage() {
            this.currentPage++;
        },

        resetUpdateUser() {
            this.userToUpdate = null;
        },

        resetRegisterUser() {
            this.userToCreate =  {
                user_department_id: null,
                role_id: null,
                firstname: null,
                surname: null,
                email: null,
                user_language: null,
            };
        },

        resetBulkRegisterFile() {
            this.selectedBulkRegisterFile = null;
        },
        
        resetPostInformation() {
            this.missingInformation = [];
            this.existingStakeholders = [];
        },

        async setIsDeleted(bool) {
            this.isDeleted = bool;
        },
        onRoleChangeEdit() {
            if (!this.userToUpdate.role_id) {
                this.userToUpdate.user_department_id = null;
            }
        },
        
        onRoleChangeCreate() {
            this.userToCreate.user_department_id = null;
    },
    }
}
</script>

<template>
    <div class="stakeholders-list">
        <div v-if="loading" class="loading-ctr">
            <i class="fa-solid fa-spinner"></i>
        </div>

        <div v-else class="table-ctr">
            <div class="top-row">
                <div class="searchbar">
                    <input type="text" v-model="keyword" :placeholder="$t('userCompany.user.search_placeholder')" @keydown.enter="_getUsersOfCompany()">
                    <button class="search-btn" @click="_getUsersOfCompany()">
                        <i class="fa-solid fa-magnifying-glass"></i>
                    </button>

                    <button class="reset-btn" @click="handleReset()" @keydown.enter="handleReset()">
                        <i class="fa-solid fa-rotate-left"></i>
                    </button>
                </div>

                <div class="buttons">
                    <button @click="_exportUsers()">
                        {{ $t('userCompany.user.export') }}
                    </button>
                </div>
            </div>

            <div class="headers-row">
                <div class="header-cell" v-for="header in tableHeaders" :key="header.key" :class="{'sorting-col': header.key == sortBy}"
                    :style="{width: header.width, textAlign: header.key != 'delete' && header.key != 'edit' ? 'left' : 'center', paddingLeft: header.key == 'row' ? '.25em' : 0 , 'pointer-events': header.no_click ? 'none' : null}"
                    @click="handleSortBy(header)"
                >
                    {{ header.text }}
                    <i v-if="sortBy == header.key " :class="`fa-solid fa-angle-${increasing ? 'down' : 'up'}`"></i>
                </div>
            </div>
            
            <div class="values-ctr">
                <div class="values-row" v-for="(user, index) in users" :key="user.user_id">
                    <div class="values-cell" v-for="cell in tableHeaders" :key="cell.key" :style="{width: cell.width}">
                        <span v-if="cell.key != 'delete' && cell.key != 'edit'">
                            <span v-if="cell.key == 'row'" style="padding-left: .25em;">
                                {{ index + 1 }}
                            </span>
                            <span v-else>
                                <span v-if="cell.key == 'user_department_name'">
                                    {{ 
                                        departments.find(x => user.user_department_id == x.value) ?
                                        departments.find(x => user.user_department_id == x.value).text : 
                                        user['user_department_name']
                                    }}
                                </span>
                                <span v-else-if="cell.key == 'role_name'">
                                    {{ 
                                        roles.find(x => user.role_id == x.value) ?
                                        roles.find(x => user.role_id == x.value).text : 
                                        user['role_name']
                                    }}
                                </span>
                                <span v-else>
                                    {{ user[cell.key] }}
                                </span>
                            </span>
                        </span>
                        <div class="flex-all-centered-row" v-else>
                            <i v-if="cell.key == 'edit'" class="fa-regular fa-pen-to-square edit-btn" :class="{'disabled': user.role_id <= $user.role_id || isDeleted}"
                                @click.stop="handleClickEdit(user)" @keydown.enter="handleClickEdit(user)"
                            >
                            </i>
                            <i v-if="cell.key == 'delete'" class="fa-regular fa-trash-can delete-btn" :class="{'disabled': user.role_id <= $user.role_id || isDeleted}"
                            @click.stop="handleClickDelete(user)" @keydown.enter="handleClickDelete(user)"
                            >
                            </i>
                        </div>
                    </div>
                </div>
            </div>

            <div class="buttons-row">
                <!-- <div class="show-deleted-users">
                    <switch-button :initialValue="isDeleted" @buttonState="handleShowDeletedUsers($event)"/>
                    <label>
                        {{ $t('userCompany.user.show_deleted') }}
                    </label>
                </div> -->

                <div class="main-btns">
                    <button class="register-btn" @click="handleClickRegister()">
                        {{ $t('userCompany.user.create_single') }}
                    </button>
                    <button class="bulk-btn" @click="handleClickBulk()">
                        {{ $t('userCompany.user.create_multiple') }}
                    </button>
                </div>
            </div>

            <div tabindex="0" class="load-more-row" v-if="loadMore" @click="handleLoadMore()" @keydown.enter="handleLoadMore()">
                {{ $t('userCompany.company.load_more') }}
                <i v-if="!isLoadingMore" class="fa-solid fa-angle-down"></i>
                <i v-else class="fa-solid fa-spinner"></i>
            </div>
        </div>

        <sust-popup
            ref="createPopup"
            size="lg"
            :title="$t('userCompany.user.update_title')"
            @ok="_registerUser()"
        >
            <div class="edit-form">
                <div class="small-field">
                    <label for="editField">
                        {{ $t('userCompany.user.role') }}
                    </label>
                    <select v-model="userToCreate.role_id" @change="onRoleChangeCreate" name="editField">
                        <option v-for="item in filteredRoles" :key="item.value" :value="item.value">
                            {{ item.text }}
                        </option>
                    </select>
                </div>
                <div class="small-field">
                    <label for="editField">
                        {{ $t('userCompany.user.department') }}
                    </label>
                    <select v-model="userToCreate.user_department_id" name="editField">
                        <option v-for="item in filteredDepartmentsCreate" :key="item.value" :value="item.value">
                            {{ item.text }}
                        </option>
                    </select>
                </div>
                <div class="small-field">
                    <label for="editField">
                        {{ $t('userCompany.user.name') }}
                    </label>
                    <input v-model="userToCreate.firstname" name="editField" type="text">
                </div>
                <div class="small-field">
                    <label for="editField">
                        {{ $t('userCompany.user.surname') }}
                    </label>
                    <input v-model="userToCreate.surname" name="editField" type="text">
                </div>
                <div class="small-field">
                    <label for="editField">
                        {{ $t('userCompany.user.email') }}
                    </label>
                    <input v-model="userToCreate.email" name="editField" type="text">
                </div>
                <div class="small-field">
                    <label for="editField">
                        {{ $t('userCompany.user.language') }}
                    </label>
                    <select name="editField" v-model="userToCreate.user_language">
                        <option value="En">
                            {{ $t('userCompany.user.en') }}
                        </option>
                        <option value="Tr">
                            {{ $t('userCompany.user.tr') }}
                        </option>
                    </select>
                </div>
            </div>
        </sust-popup>

        <sust-popup
            ref="editPopup"
            size="lg"
            :title="$t('userCompany.user.update_title')"
            @ok="_updateUser()"
            @onHide="resetUpdateUser()"  
        >
            <div class="edit-form" v-if="userToUpdate">
                <div class="small-field">
                    <label for="editField">
                        {{ $t('userCompany.user.role') }}
                    </label>
                    <select v-model="userToUpdate.role_id" @change="onRoleChangeEdit" name="editField">
                        <option v-for="item in filteredRoles" :key="item.value" :value="item.value">
                            {{ item.text }}
                        </option>
                    </select>
                </div>
                <div class="small-field">
                    <label for="editField">
                        {{ $t('userCompany.user.department') }}
                    </label>
                    <select v-model="userToUpdate.user_department_id" name="editField">
                        <option v-for="item in filteredDepartmentsUpdate" :key="item.value" :value="item.value">
                            {{ item.text }}
                        </option>
                    </select>
                </div>
                <div class="small-field">
                    <label for="editField">
                        {{ $t('userCompany.user.name') }}
                    </label>
                    <input v-model="userToUpdate.firstname" name="editField" type="text">
                </div>
                <div class="small-field">
                    <label for="editField">
                        {{ $t('userCompany.user.surname') }}
                    </label>
                    <input v-model="userToUpdate.surname" name="editField" type="text">
                </div>
                <div class="small-field">
                    <label for="editField">
                        {{ $t('userCompany.user.email') }}
                    </label>
                    <input v-model="userToUpdate.email" name="editField" type="text">
                </div>
                <div class="small-field">
                    <label for="editField">
                        {{ $t('userCompany.user.language') }}
                    </label>
                    <select name="editField" v-model="userToUpdate.user_language">
                        <option value="En">
                            {{ $t('userCompany.user.en') }}
                        </option>
                        <option value="Tr">
                            {{ $t('userCompany.user.tr') }}
                        </option>
                    </select>
                </div>
            </div>
        </sust-popup>

        <sust-popup
            ref="deletePopup"
            size="sm"
            :title="$t('userCompany.user.delete_title')"
            @ok="_deleteUser()"
            @hidden="resetUpdateUser()"
        >
            <div>
                {{ $t('userCompany.user.delete_text') }}
            </div>
        </sust-popup>

        <sust-popup
            ref="bulkPopup"
            size="sm"
            :title="$t('registerForm.buttonTitles.createBulkUser')"
            :footer="false"
            @hidden="resetBulkRegisterFile"
        >
            <div class="bulk-body">
                <ul>
                    <li>
                        {{ $t('userCompany.user.bulk_register_descriptions.1') }}
                    </li>
                    <li>
                        {{ $t('userCompany.user.bulk_register_descriptions.2') }}
                    </li>
                    <li>
                        {{ $t('userCompany.user.bulk_register_descriptions.3') }}
                    </li>
                </ul>

                <div class="file-selector-ctr">
                    <label for="input" @click="handleClickChooseFile()">
                        {{ $t('userCompany.user.choose_file') }}
                    </label>
                    <input ref="fileInput" name="input" type="file" @change="handleChooseFile($event)">
                    <div :style="{color: selectedBulkRegisterFile ? 'var(--sustainfinity-green)' : 'black', fontWeight: selectedBulkRegisterFile ? 'bold' : 'normal'}">
                        {{ selectedBulkRegisterFile ? selectedBulkRegisterFile.name : $t('userCompany.user.no_files') }}
                    </div>
                </div>
                <div class="buttons">
                    <button @click="_getSampleExcel()">
                        {{ $t('userCompany.user.sample_excel') }}
                    </button>
                    <div class="main-btns">
                        <button @click="handleBulkRegisterCancel()">
                            {{ $t('myCompanies.company_table.cancel') }}
                        </button>
                        <button @click="handleBulkRegisterConfirm()">
                            {{ $t('myCompanies.company_table.ok') }}
                        </button>
                    </div>
                </div>
            </div>
        </sust-popup>

        <sust-popup
            ref="missingInfoPopup"
            size="lg"
            :title="$t('registerForm.postRegisterInformation.title')"
            :footer="false"
            @hidden="resetPostInformation"
        >
            <div class="flex-all-centered-row" style="font-weight: bold; font-size: .9vw; color: var(--invalid-input); margin-bottom: 1em;">
                {{ $t('registerForm.postRegisterInformation.one_time_only') }}
            </div>

            <div class="flex-all-centered-row post-info-tabs">
                <div :class="{'selected-tab': selectedPostInfoTab === 'missing'}"
                    @click="() => selectedPostInfoTab = 'missing'"
                >
                    {{ $t('registerForm.postRegisterInformation.missing') }}
                </div>
                <div :class="{'selected-tab': selectedPostInfoTab === 'existing'}"
                    @click="() => selectedPostInfoTab = 'existing'"
                >
                    {{ $t('registerForm.postRegisterInformation.existing') }}
                </div>
            </div>

            <div class="flex-all-centered-row post-info-headers">
                <div v-for="header in postInfoTableHeaders" :key="header.key"
                    :style="{'width': header.width}"
                >
                    <span v-if="header.key === 'row'">
                        #
                    </span>
                    <span v-else>
                        {{ header.text }}
                    </span>
                </div>
            </div>
            <div class="flex-all-centered-row post-info-rows" v-for="(item, idx) in filteredPostInfoTable" :key="idx">
                <div v-for="header in postInfoTableHeaders" :key="header.key"
                    :style="{'width': header.width}"
                >
                    <span v-if="header.key === 'row'">
                        {{ idx+1 }}
                    </span>
                    <span v-else>
                        {{ item[header.key] }}
                    </span>
                </div>
            </div>
        </sust-popup>
    </div>
</template>

<style lang='scss' scoped>
    * {
        word-break: break-word;
        hyphens: auto;
        -ms-hyphens: auto;
        -moz-hyphens: auto;
        -webkit-hyphens: auto;
    }

    .stakeholders-list {
        z-index: 20;
        width: 100%;
        background-color: none;
        justify-self: center;

        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
    }

    .loading-ctr {
        width: 100%;
        background-color: #fff5ee;
        text-align: center;
        display: flex;
        flex-direction: row;
        justify-content: center;
        padding: 1em;
        font-size: 1.5em;
    }

    .table-ctr {
        width: 100%;
        background-color: #fff5ee;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;

        > .top-row {
            padding: 0 .5em;
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-content: center;

            > .searchbar {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;

                align-self: flex-start;
                width: 50% !important;
                margin: 0 !important;
                margin-top: 1em !important;
                    
                > input {
                    width: 100%;
                    border: 0;
                    outline: thin solid lightgray;
                    border-radius: 100px;
                    padding: .5em;
                    background-color: #fff9f4;

                    &:focus {
                        outline: thin solid gray !important;
                    }
                }

                position: relative;
                > .search-btn {
                    transform-origin: (50%, 50%);
                    position: absolute;
                    right: 4.5em;
                    top: 50%;
                    transform: translateY(-60%);
                    background: none;
                    border: 0;
                    outline: 0;
                    scale: .8;
                    transition: all 150ms;
                    &:hover {
                        scale: 1;
                    }

                    &:focus {
                        outline: thin solid lightgray !important;

                        > i {
                            color: black !important;
                        }
                    }
                }

                > .reset-btn {
                    position: relative;
                    background-color: #ffeadb;
                    color: gray;
                    padding: .3em 1em;
                    margin-left: .5em;
                    border: 0;
                    outline: thin solid gray;
                    border-radius: .5em;
                    
                    transition: all 150ms;
                    &:hover {
                        filter: brightness(90%);
                    }

                    &:focus {
                        outline: thin solid black !important;
                    }

                    &:active {
                        outline: .125em solid black !important;
                    }
                }
            }

            > .buttons {
                margin-top: 1em;
                > button {
                    &:first-of-type {
                        color: whitesmoke;
                        margin-left: .3em;
                        border: 0;
                        outline: 0;
                        border-radius: .5em;
                        padding: .5em;
                        min-width: 7em;

                        background-color: var(--sustainfinity-blue);
                        &:hover {
                            background-color: var(--sustainfinity-blue--hover);
                        }

                        &:focus {
                            outline: thin solid black !important;
                        }

                        &:active {
                            outline: .15em solid black !important;
                        }
                    }
                }
            }
        }

        > .headers-row {
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;

            border-bottom: thin solid var(--sustainfinity-navy);

            > .header-cell {
                padding: .5em 0;
                text-align: left;
                font-size: .75vw;
                font-weight: bold;
                color: var(--sustainfinity-navy);

                cursor: pointer;
                &:hover {
                    text-decoration: underline;
                }
            }
            
            > .sorting-col {
                text-decoration: underline;
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-content: center;

                > i {
                    text-decoration: none !important;
                    height: fit-content !important;
                    padding-left: .25em;
                    transform: translateY(25%);
                }
            }
        }

        > .values-ctr {
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;

            > .values-row {
                min-height: 30px;
                width: 100%;
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;

                border-bottom: thin solid lightgray;

                > .values-cell {
                    padding: .3em 0;
                    text-align: left;
                    font-size: .75vw;
                }
            }
        }

        > .buttons-row {
            padding: 1em;
            width: 100%;
            text-align: center;
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            align-items: center;

            .main-btns {
                text-align: center;
                display: flex;
                flex-direction: row;
                justify-content: flex-end;
                align-items: center;

                > button {
                    font-size: .75vw;
                    color: whitesmoke;
                    padding: .5em;
                    margin-left: .5em;
                    border: 0;
                    outline: 0;
                    border-radius: .25em;
                    filter: none !important;

                    transition: background-color 150ms;

                    &:focus {
                        outline: thin solid black !important;
                    }

                    &:active {
                        outline: .125em solid black !important;
                    }
                }

                > .register-btn {
                    background-color: var(--sustainfinity-green);

                    &:hover {
                        background-color: var(--sustainfinity-green--hover) !important;
                    }
                }

                > .bulk-btn {
                    background-color: var(--sustainfinity-blue);

                    &:hover {
                        background-color: var(--sustainfinity-blue--hover) !important;
                    }
                }   
            }

            > .show-deleted-users {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                
                > label {
                    padding: 0;
                    margin: 0;
                    height: fit-content !important;
                    font-weight: bold;
                }
            }
        }

        > .load-more-row {
            padding: 1em;
            width: 100%;
            text-align: center;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;

            transition: background-color 150ms;
            cursor: pointer;
            &:hover {
                background-color: rgba(0, 0, 0, 0.1);
            }

            > i {
                padding-left: .5em;
            }
        }
    }

    .edit-btn, .delete-btn {
        transition: filter 150ms;
        cursor: pointer;
        &:hover {
            filter: brightness(80%);
        }
    }

    .edit-btn {
        color: var(--sustainfinity-blue);
    }

    .delete-btn {
        color: var(--invalid-input);
    }

    .edit-btn.disabled, .delete-btn.disabled {
        cursor: not-allowed !important;
        color: gray !important;
    }

    .fa-spinner {
        color: var(--sustainfinity-blue);
        animation: Spin 500ms linear infinite;
    }

    @keyframes Spin {
        0% {
            transform: rotate(0);
        } 100% {
            transform: rotate(360deg);
        }
    }

    .edit-form {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        align-items: stretch;
        flex-wrap: wrap;

        > .small-field {
            width: 40%;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;

            > * {
                text-align: left;
                width: 100%;
            }

            > label {
                margin: 0dvh;
            }

            > input, textarea, select {
                padding: .35em .1em;
                border-radius: .25em;
                border: 0;
                outline: thin solid lightgray;

                &:focus {
                    outline: thin solid black !important;
                }
            }
        }
    }

    .bulk-body {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        > .file-selector-ctr {
            padding: .5em;
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            border-bottom: thin solid lightgray;

            > input {
                display: none;
            }

            > label {
                text-align: center;
                width: 50%;
                border: 0;
                outline: thin solid gray;
                padding: .5em 1em;
                line-height: 1em;
                border-radius: .2em;
                background-color: rgb(227, 227, 227);

                transition: background-color 150ms;

                &:hover {
                    background-color: lightgray;
                }
                
                &:focus {
                    outline: thin solid black;
                }

                &:active {
                    outline: .125em solid black;
                }
            }
        }

        > .buttons {
            padding: .5em;
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;

            > button {
                color: whitesmoke;
                margin-left: .3em;
                border: 0;
                outline: 0;
                border-radius: .5em;
                padding: .5em;
                min-width: 7em;

                background-color: var(--sustainfinity-blue);
                &:hover {
                    background-color: var(--sustainfinity-blue--hover);
                }
            }

            > .main-btns {
                display: flex;
                flex-direction: row;
                justify-content: flex-end;

                > button {
                    color: whitesmoke;
                    margin-left: .3em;
                    border: 0;
                    outline: 0;
                    border-radius: .5em;  
                    padding: .5em;
                    min-width: 7em;

                    &:first-of-type {
                        background-color: var(--invalid-input);
                        &:hover {
                            background-color: var(--invalid-input--hover);
                        }
                    }

                    &:nth-of-type(2) {
                        background-color: var(--sustainfinity-green);
                        &:hover {
                            background-color: var(--sustainfinity-green--hover);
                        }
                    }
                }
            }
        }
    }
    
    .post-info-tabs {
        border-radius: 100px;
        border: thin solid var(--sustainfinity-navy);
        overflow: hidden !important;

        > div {
            text-align: center;
            width: 100%;
            font-weight: bold;
            background-color: whitesmoke;
            color: var(--sustainfinity-navy);

            &:first-of-type {
                border-right: thin solid var(--sustainfinity-navy);
            }

            cursor: pointer;
            transition: background-color 150ms;
            &:hover {
                background-color: lightgray;
            }
        }

        > .selected-tab {
            background-color: var(--sustainfinity-navy) !important;
            color: whitesmoke !important;
        }
    }

    .post-info-headers {
        margin-top: 1em;
        background-color: var(--sustainfinity-navy);
        color: whitesmoke;
        font-weight: bold;
        border-top-left-radius: .5em;
        border-top-right-radius: .5em;
        overflow: hidden;
        text-align: center;

        > div {
            padding: .25em;
        }
    }

    .post-info-rows {
        background-color: whitesmoke;
        color:  var(--sustainfinity-navy);
        font-weight: bold;
        text-align: center;
        border-bottom: thin solid lightgray;

        &:last-of-type {
            border-top-left-radius: .5em;
            border-top-right-radius: .5em;
            overflow: hidden;
        }

        > div {
            padding: .25em;
        }
    }

</style>